import { Link } from '@/components/atoms/Link';
import TextButton from '@/components/atoms/TextButton/TextButton';
import { useZipContext } from '@/context/ZipContext';
import { AllInternalLinks } from '@/lib/internalLinks';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { FC, useRef, useState } from 'react';
import { ChevronUp } from 'react-feather';

const InternalLinksColumn = ({
  zip,
  list,
}: {
  zip: string;
  list: { title: string; list: { label: string; href: string }[] }[];
}) => {
  return (
    <ul className="w-full columns-1 gap-xl m:columns-2 ml:columns-4">
      {list.map((itemList, index) => (
        <li key={`${itemList.title}-${index}`} className="mb-l flex flex-col">
          <div className="flex items-center gap-l">
            <h4 className="whitespace-nowrap text-h4Regular text-neutral-600">
              {itemList.title}
            </h4>
            <div className="h-px w-full bg-neutral-300" />
          </div>
          <div className="flex flex-col gap-s">
            {itemList.list.map((item, innerIndex) => (
              <div
                key={`${item.label}-${index}-${innerIndex}`}
                className="flex items-center"
              >
                <Link
                  href={`/build/${zip}/${item.href}`}
                  className="line-clamp-1 overflow-ellipsis text-body1Medium text-text-link-action"
                >
                  {item.label}
                </Link>
              </div>
            ))}
          </div>
        </li>
      ))}
    </ul>
  );
};
export const InternalLinks: FC = () => {
  const { preferredZip: zip } = useZipContext();
  const [expanded, setExpanded] = useState(false);
  const columnsRef = useRef<HTMLDivElement>(null);

  return (
    <div className="flex w-full flex-col pb-xl">
      <h3 className="mb-xl text-h3SemiBold text-neutral-900">
        What others are searching for
      </h3>
      <div
        className="w-full overflow-hidden"
        style={{
          maxHeight: expanded
            ? `${columnsRef.current?.getBoundingClientRect().height}px`
            : '300px',
        }}
      >
        <div className="flex w-full" ref={columnsRef}>
          <InternalLinksColumn zip={zip} list={AllInternalLinks} />
        </div>
      </div>
      <div className="flex w-full justify-end">
        <div className="flex">
          <TextButton
            aria-label={`Show ${expanded ? 'less' : 'more'} search suggestions`}
            onClick={() => setExpanded(!expanded)}
          >
            <div className="inline-flex items-center gap-s text-body2Medium">
              Show {expanded ? 'less' : 'more'}
              {expanded ? (
                <ChevronUp className="size-[20px]" />
              ) : (
                <ChevronDownIcon className="size-[20px]" />
              )}
            </div>
          </TextButton>
        </div>
      </div>
    </div>
  );
};
